


import {SessionBookingVM} from './SessionBookingVM'; 
export class ClientDashboardVM {
    
    bookedSessions?: number;
    
    attendedSessions?: number;
    
    upcomingSessions?: number;
    
    sessionsUpcoming?: SessionBookingVM[];
    
    sessionHistory?: SessionBookingVM[];
    
}
